<template>
  <div class="contents px-csv">
    <!-- マイタスク「残業確認」タブ -->
    <template v-if="isLoading">
      <template v-if="!isInit || !isError">
        <loading :message="'データ読み込み中...'"></loading>
      </template>
    </template>
    <template v-else>
      <div class="flex">
        <div class="baseinfo control"><!-- baseinfo -->

          <div class="period-selecter">
            <div class="item ">
              <p>締め年月</p>
              <month-picker v-model="yearMonthForMonthPicker" @update:modelValue="changeMonth"  :error="getError(form, 'year') || getError(form, 'month')"
                :disabled="isLoading" :clearable=false></month-picker>
            </div>

            <div class="item ">
              <p>締め日</p>
              <input-text :type="'number'" v-model="shimeDay" inputmode="numeric" class="small" :min="1" :max="31"
                v-on:change="changeShimeDay" :error="getError(form, 'shime')"></input-text>
            </div>
          </div>

        </div><!-- /baseinfo -->

        <div class="maininfo flex">
          <div class="btn-container">
              <button type="button" class="btn success" @click="checkOver45ZangyouList" :disabled="isLoading || isCreating">
                <template v-if="isCreating">
                  <i class="fa-solid fa-spinner fa-spin-pulse"></i>残業45時間以上のスタッフを確認中…
                </template>
                <template v-else>
                  <i class="fa-solid fa-floppy-disk"></i>残業45時間以上のスタッフを確認する
                </template>
              </button>
          </div>
        </div><!-- /maininfo -->

      </div>

      <!-- < v-if="isChecked && !isListError"> -->
      <div v-if="isChecked && !isListError">
        <template v-if="isListChecking">
          <loading :isLoading="isLoading" :message="'処理中...'"></loading>
        </template>
        <template v-if="canDownLoad && !isListChecking">
          <h3 class="info">45時間以上の残業勤務を行ったスタッフのデータはありません</h3>
        </template>
        <template v-if="!canDownLoad && !isListChecking">

          <!-- 残業45時間以上のスタッフリスト -->
          <div>
                <h3>残業45時間以上のスタッフの残業時間</h3>
                <scroll-table v-if="checkListInfo.zangyouList.length > 0">
                  <table>
                    <thead>
                      <tr>
                        <th>&nbsp;</th>
                        <th>社員番号</th>
                        <th>名前</th>
                        <th>就業場所</th>
                        <th>期間</th>
                        <th>残業時間合計</th>
                        <th>法定内残業</th>
                        <th>時間外</th>
                        <th>深夜</th>
                        <th>休日</th>
                        <th>休日深夜</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in checkListInfo.zangyouList" :key="row.kintai_summary_id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ row.staff_code }}</td>
                        <td>{{ row.staff_name }}</td>
                        <td>{{ row.syuugyou_basyo_name }}</td>
                        <td>{{ dateFormat(row.start_date) }}～{{ dateFormat(row.end_date) }}</td>
                        <td>{{ row.sumZangyouTimes}}</td>
                        <td>{{ toHHMM(row.houteinai_zangyou_times) }}</td>
                        <td>{{ toHHMM(row.zangyou_times) }}</td>
                        <td>{{ toHHMM(row.shinya_zangyou_times)}}</td>
                        <td>{{ toHHMM(row.kyuujitsu_zangyou_times)}}</td>
                        <td>{{ toHHMM(row.kyuujitsu_shinya_zangyou)}}</td>
                      </tr>
                    </tbody>
                  </table>
                </scroll-table>
                <p v-else>該当者はありません</p>
          </div>
          <!-- /残業45時間以上のスタッフリスト -->
        </template>

      </div>

    </template>


  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, Ref, ref, computed } from 'vue';
import { dateFormat, dateFormatMMDD, timeFormat, timeToHHmm } from "@/filters/common";
import { useInit } from '@/composable/mytask/over45zangyou/init';
import { useList } from '@/composable/mytask/over45zangyou/list';
import { ZangyouCheckListReq } from "@/types/MyTask";
import { MonthPickerModelValue } from "../../form/MonthPicker.vue";
import { useForm } from '@/composable/form/form';
import { useRouter } from 'vue-router';
import { RouterConst } from '@/const/Router';

export default defineComponent({
  props: ['options', 'tab'],
  setup(props) {

    // 初期化
    const isInit = ref(false);
    const isChecked = ref(false);
    const canDownLoad = ref(false);
    const yearMonth = ref('');

    const { isLoading, isError, form } = useInit();
    const { isListChecking, isListError, getList, checkListInfo } = useList();

    const { getError } = useForm();

    const router = useRouter();

    onMounted(async () => {

    });

    // TODO　composable から設定すること
    const isCreating = ref(false);


    // 年月指定用
    let year = ref(new Date().getFullYear()); // 初期値として現在の西暦をセット
    let month = ref(new Date().getMonth() + 1); // 初期値として現在の月をセット

    // MonthPickerに渡すための年月obj
    const yearMonthForMonthPicker = computed((): MonthPickerModelValue => {
      return {
        year: year.value,
        month: month.value - 1 // プログラム上の月番号と表示上の月名の補正
      }
    });

    // MonthPickerで年月を決定した際に実行
    const changeMonth = async (val: MonthPickerModelValue) => {
      month.value = val.month + 1 // プログラム上の月番号と表示上の月名の補正
      year.value = val.year

      canDownLoad.value = false;
      isChecked.value = false;
    };

    const shimeDay = ref('20');

    const changeShimeDay = (() => {
      canDownLoad.value = false;
      isChecked.value = false;
    });

    /** 残業45時間以上のスタッフリストを取得する */
    const checkOver45ZangyouList = (async () => {
      isChecked.value = true;
      canDownLoad.value = false;

      const params: ZangyouCheckListReq = {
        year: yearMonthForMonthPicker.value.year,
        month: yearMonthForMonthPicker.value.month + 1,
        shime: parseInt(shimeDay.value, 10)
      }

      await getList(params);
    });

    const toHHMM = ((val: any) => {
      let str = val.toString();

      if (str.length == 0) {
        return val;
      }
      let tmp = str.split(':');
      return tmp[0] + ':' + tmp[1];
    })

    return {
      isLoading,
      isError,
      isInit,
      form,
      dateFormat,
      dateFormatMMDD,
      timeFormat,
      toHHMM,
      RouterConst,
      isChecked,
      canDownLoad,
      yearMonth,
      shimeDay,
      yearMonthForMonthPicker,
      changeMonth,
      checkOver45ZangyouList,
      changeShimeDay,
      getError,
      isListError,
      isListChecking,
      isCreating,
      getList,
      checkListInfo,
    }
  },
  components: {

  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/px.scss';
</style>
